import React from 'react'
import { ReactComponent as ChooseLanguageSVG } from '../../../assets/images/choose-language.svg'

interface ChooseLanguageProps extends React.SVGProps<SVGSVGElement> {
  clothesColor: string
  skinColor: string
  redPuzzleColor: string
}

const ChooseLanguageIllustration: React.FC<ChooseLanguageProps> = ({
  clothesColor,
  skinColor,
  redPuzzleColor,
  ...props
}) => {
  // Function to set the fill color of specific paths representing clothes
  const customizeClothesColor = (svg: React.ReactNode) => {
    return React.cloneElement(svg as React.ReactElement, {
      style: {
        '--clothes-color': clothesColor,
        '--skin-color': skinColor,
        '--red-puzzle-color': redPuzzleColor,
      } as React.CSSProperties,
    })
  }

  return customizeClothesColor(<ChooseLanguageSVG {...props} />)
}

export default ChooseLanguageIllustration
